<template>
  <a class="thumb-post" :href="blogBasePath + '/posts/' + this.post.slug + appQueryParam">
    <div class="thumb-post__figure">
      <img :src="post.feature_image" :alt="post.feature_image_alt" />
      <!--<div class="skloader"></div>-->
    </div>
    <div class="thumb-post__content">
      <template v-if="!isRelated">
        <h4 class="thumb-post__title">
          {{ post.title }}
        </h4>
      </template>
      <template v-else>
        <div class="thumb-post__title">
          {{ post.title }}
        </div>
      </template>

      <div class="thumb-post__excerpt" v-if="showExcerpt">
        {{ $utils.truncate(post.custom_excerpt, 135) }}
      </div>
      <div class="thumb-post__tax">
        {{ $utils.capitalize(categoryName) }}
      </div>
    </div>
  </a>
</template>
<script>
import { mapGetters } from "vuex";
import { findBlogCategoryNameKey } from "../../../constants/blog-categories";

export default {
  name: "BlogPostThumb",
  props: {
    showExcerpt: Boolean,
    isRelated: Boolean,
    post: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      blogBasePath: "blogBasePath",
    }),
    categoryName() {
      const nameKey = findBlogCategoryNameKey(this.post.primary_tag?.slug);
      if (nameKey) return this.$t(nameKey, this.lang);

      // Categoría no registrada en el config i18n: se mantiene el comportamiento
      // anterior como fallback en vez de dejar el texto en blanco.
      return this.post.primary_tag?.name;
    },
    categorySlug() {
      return this.post.primary_tag?.slug;
    },
    appQueryParam() {
      if (this.$store.state.cookies.sourceApp == "true") return "?source=app";
      return "";
    },
    lang() {
      return this.$route.meta?.lang || this.$i18n.locale;
    },
  },
};
</script>
<style lang=""></style>
